import React from 'react';
import { List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { NavLink } from 'react-router-dom';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
import FavoriteIcon from '@mui/icons-material/Favorite';
import SettingsIcon from '@mui/icons-material/Settings';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../../Redux/Auth/Action";
import {useNavigate} from "react-router-dom";
const Sidebar = () => {
  const [isSidebarOpen, setIsSidebarOpen] = React.useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  const handleLogout = () => {
    dispatch(logout()).then(()=>{
      navigate("/")
      window.location.reload();
    });
   
  };

  const menuItems = [
    { label: 'Profile', path: '/account/profile', icon: <AccountCircleIcon /> },
    { label: 'Orders', path: '/account/order', icon: <ShoppingBagIcon /> },
    { label: 'Wishlist', path: '/account/wishlist', icon: <FavoriteIcon /> },
    //{ label: 'Settings', path: '/account/settings', icon: <SettingsIcon /> },

  ];

  return (
    <div >
      <div
        className={` top-0 left-0 h-[86.1vh] bg-gray-100 text-white transition-all duration-300 z-40 ${
          isSidebarOpen ? 'w-64' : 'w-16'
        } md:w-64`}
      >
        <div className="md:p-6 p-4 flex justify-between">
          <h2 className={`text-2xl font-semibold ${isSidebarOpen ? 'block' : 'hidden'} md:block`}>
            User Dashboard
          </h2>
          <button
        className=" text-white focus:outline-none z-50 md:hidden "
        onClick={toggleSidebar}
      >
        {isSidebarOpen ? <CloseIcon /> : <MenuIcon />}
      </button>
        </div>
        <List>
          {menuItems.map((item) => (
            <ListItem button key={item.label} component={NavLink} to={item.path} onClick={toggleSidebar}>
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.label} className={`${isSidebarOpen ? 'block' : 'hidden'} md:block`} />
            </ListItem>
          ))}
             <ListItem button key="Logout"  onClick={handleLogout}>
              <ListItemIcon><ExitToAppIcon /> </ListItemIcon>
              <ListItemText primary="Logout" className={`${isSidebarOpen ? 'block' : 'hidden'} md:block`} />
            </ListItem>
        </List>
      </div>
    </div>
  );
};

export default Sidebar;
